export default __webpack_public_path__ + "static/media/disc1-red.f082b657.jpg";